// extracted by mini-css-extract-plugin
export default {"wrap":"OG-z","fullWidth":"PG-z","hideOnDesktop":"QG-z","content":"RG-z","hasOpenedNav":"SG-z","crumbsList":"TG-z","dropdownsWrap":"UG-z"};